"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
var react_1 = __importDefault(require("react"));
var Box = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, label = _a.label, _c = _a.wrapperClass, wrapperClass = _c === void 0 ? "" : _c;
    return (react_1.default.createElement("div", { className: "ai-center d-f py1" },
        react_1.default.createElement("p", { className: "d-ib pr2" }, label),
        react_1.default.createElement("div", { className: "".concat(wrapperClass, " bg-light4 d-ib rnd") },
            react_1.default.createElement("div", { className: "bdr2 bdr-dark7 bg-light4 d-b dark4 rnd ".concat(className).trimEnd() }, children))));
};
exports.Box = Box;
